module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "product-card",
    class: {
      'side-tab-view': _vm.sideTabView,
      'px-0': _vm.onMobile
    }
  }, [_c('v-flex', {
    staticClass: "product-info",
    attrs: {
      "pa-0": ""
    },
    on: {
      "mouseenter": function($event) {
        _vm.is_component_hover = true
      },
      "mouseleave": function($event) {
        _vm.is_component_hover = false
      }
    }
  }, [_c('v-flex', {
    staticClass: "product-cover",
    class: {
      'px-0': _vm.onMobile
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "product-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.price)))]), _vm._v(" "), _c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + _vm.item.covers[0].cover.url + ')',
    })
  }, [_c('div', {
    staticClass: "full-overlay"
  }, [_c('div', {
    staticClass: "hover-info"
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "artist-name"
  }, [_vm._v(_vm._s(_vm.item.merchant.username))])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 dflex justify-space-between align-center w-100"
  }, [(!_vm.hidePriceOverlay) ? _c('div', {
    staticClass: "items-price"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.price)))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-plus"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/plus.svg"),
      "width": "15px"
    }
  })])])])]), _vm._v(" "), (_vm.currentUser && !_vm.hideOverlay) ? _c('v-flex', {
    staticClass: "product-actions",
    attrs: {
      "xs12": "",
      "relative": ""
    },
    on: {
      "click": function($event) {
        _vm.currentUser !== null ? _vm.$router.push({
          name: 'SingleProduct',
          params: {
            id: _vm.item.id
          }
        }) : _vm.spotlightVideo()
      }
    }
  }, [(!_vm.hidePriceOverlay) ? _c('div', {
    staticClass: "product-label"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.price)))]) : _vm._e(), _vm._v(" "), (!_vm.hideMoreOptions) ? _c('span', [(_vm.willMenuRender) ? _c('v-menu', {
    staticClass: "product-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.is_menu_hover = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [(_vm.item.merchant.id != _vm.currentUser.id) ? _c('v-list-tile', {
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openHideDialog()
      }
    }
  }, [_c('v-list-tile-title', [_c('label', [_vm._v("Hide")])])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.currentUser !== null ? _vm.$router.push({
          name: 'SingleProduct',
          params: {
            id: _vm.item.id
          }
        }) : _vm.spotlightVideo()
      }
    }
  }, [(!_vm.noMeta) ? _c('v-flex', {
    staticClass: "product-detail"
  }, [_c('p', {
    staticClass: "product-name cursor-pointer"
  }, [_vm._v("\n          " + _vm._s(_vm.item.name) + "\n        ")]), _vm._v(" "), _c('user-tag', {
    staticClass: "tag",
    attrs: {
      "user": _vm.item.merchant
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.altMeta) ? _c('div', {
    staticClass: "mt-2 box__footer alt-meta"
  }, [_c('div', {
    staticClass: "alt-meta-name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "alt-meta-user"
  }, [_c('b', {
    staticClass: "text-capitalize"
  }, [_vm._v(_vm._s(_vm.item.merchant.username))])]), _vm._v(" "), (_vm.altMetaPrice) ? _c('div', {
    staticClass: "alt-meta-price"
  }, [_c('b', {
    staticClass: "text-capitalize"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.item.price)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.forCollection || _vm.playlistId) ? _c('v-menu', {
    staticClass: "track-menu",
    attrs: {
      "offset-y": "",
      "close-on-content-click": false,
      "nudge-width": 100
    }
  }, [_c('v-btn', {
    staticClass: "toolbar-btn",
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.is_menu_hover = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-card', [_c('v-list', [_c('v-list-tile', {
    key: "remove",
    staticClass: "default-menu-item track-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.openRemoveFromCollectionModal()
      }
    }
  }, [_c('v-list-tile-title', [_c('div', {
    staticClass: "menu-list-item dflex align-center"
  }, [_c('label', {
    staticClass: "ml-0 black--text"
  }, [_vm._v("Remove")])])])], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showMerchModal) ? _c('merch-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.closeMerchDialog,
      "shareProduct": _vm.openShareDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showShareModal) ? _c('share-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.closeShareDialog
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_hide_dialog) ? _c('v-dialog', {
    attrs: {
      "content-class": "my-dialog-1"
    },
    model: {
      value: (_vm.show_hide_dialog),
      callback: function($$v) {
        _vm.show_hide_dialog = $$v
      },
      expression: "show_hide_dialog"
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm.item.covers[0].cover.url,
      "height": "125px",
      "contain": ""
    }
  }), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("\n          Are you sure you want to hide this product?\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          You won't be able to see it anymore, unless you visit the artists\n          profile or download the song.\n        ")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "grey"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_hide_dialog = false
      }
    }
  }, [_vm._v("No, cancel please!")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideProduct()
      }
    }
  }, [_vm._v("Yes, hide it!")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "logout-modal"
    },
    model: {
      value: (_vm.show_logout_modal),
      callback: function($$v) {
        _vm.show_logout_modal = $$v
      },
      expression: "show_logout_modal"
    }
  }, [_c('logoutModal')], 1), _vm._v(" "), (_vm.forCollection) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_remove_from_collection_modal),
      callback: function($$v) {
        _vm.show_remove_from_collection_modal = $$v
      },
      expression: "show_remove_from_collection_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Remove from Collection\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to remove this product from collection?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeFromCollection()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1) : (_vm.playlistId) ? _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_remove_from_collection_modal),
      callback: function($$v) {
        _vm.show_remove_from_collection_modal = $$v
      },
      expression: "show_remove_from_collection_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n        Remove from Playlist\n      ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Are you sure you want to remove this product from playlist?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "black",
      "dark": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.removeFromPlaylist('shop_product', _vm.item.id, _vm.playlistId);
        _vm.show_remove_from_collection_modal = false
      }
    }
  }, [_vm._v("\n          Yes\n        ")])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3790e830","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/productcard.vue
// module id = 1683
// module chunks = 180